import {register} from '../vendor/theme-scripts/theme-sections';

import hideElement from '../util/hide-element';
import showElement from '../util/show-element';

const selectors = {
  toggle: '[dynamic-image-toggle]',
  image: '[dynamic-image]'
};

const sections = [];

class ImageAndTextDynamic {
  constructor(section) {
    this.section = section;
    this.id = section.id;
    this.container = section.container;
    this.init();
  }

  init() {
    console.log('ImageAndTextDynamic.init')
    const toggle = this.container.querySelectorAll(selectors.toggle);
    toggle.forEach((el) => {
      const handle = el.getAttribute(`data-handle`),
            scope = this;
      el.addEventListener('mouseenter', function(evt) {
        scope.goTo(handle);
      })
    });
  }

  goTo(handle) {
    const toggle = this.container.querySelectorAll(selectors.toggle);
    toggle.forEach((el) => {
      const elHandle = el.getAttribute(`data-handle`);
      if( handle == elHandle) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });

    const image = this.container.querySelectorAll(selectors.image);
    image.forEach((el) => {
      const elHandle = el.getAttribute(`data-handle`);
      if( handle == elHandle) {
        showElement(el);
      } else {
        hideElement(el);
      }
    });
  }
}

const imageAndTextDynamic = {
  onLoad() {
    console.log(`imageAndTextDynamic`);
    sections[this.id] = new ImageAndTextDynamic(this);
  },
};


register('image-and-text-dynamic', imageAndTextDynamic);
